import {
    changeEvent,
    clickEvent, customDocumentEvent, customEvent,
    dispatchCustomEvent,
    documentLoadEvent, fireChangeEvent, fireInputEvent, inputEvent
} from "../../../../../webpack/modules/events";
import {calculateCustomSizePrice, calculatePrice} from "../../../../../webpack/modules-optimized/product";
import {
    slideDown,
    hideElement,
    showElement,
    slideUp
} from "../../../../../webpack/modules-optimized/element-visibility";
import {getNewTomSelectQuantity, initTomSelectQuantity} from "../../../../../webpack/modules-optimized/tomselect";
import {hideOptionErrors, updatePriceElements} from "../../../../../webpack/modules-optimized/product-page";
import {formatPrice} from "../../../../../webpack/modules-optimized/price";

documentLoadEvent(function() {
    initTomSelectQuantities();
    selectUniqueCustomSizeOption();
});

changeEvent('#product-page .options[data-option-type="multiple-selectable"] input[name="size"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = null;
    let previewText = element.dataset.previewText;
    let sizesSelected = offcanvas.querySelectorAll('input[name="size"]:checked');
    let confirmButton = offcanvas.querySelector('.continue-configuration');
    let size = element.closest('.size') || element.nextElementSibling;
    let quantity = size.querySelector('.quantity-selector');

    if (offcanvas) previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);

    dispatchCustomEvent(
        'productSizeChanged',
        {
            'option': offcanvas,
            'container': container,
            'previewElement': previewElement,
            'previewText': previewText
        }
    );

    if (element.checked && !quantity.classList.contains('quantity-add-to-cart')) quantity.classList.add('quantity-add-to-cart');
    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    if (sizesSelected.length > 0) slideDown(confirmButton);
    else hideElement(confirmButton);
    updatePriceElements(container);
    hideOptionErrors(offcanvas);
});

clickEvent('#product-page .options[data-option-type="multiple-selectable"] .size-box-container:not(.no-block-open)', false, function(element, event) {
    let target = event.target;
    let tomselect = element.querySelector('.quantity-selector').tomselect;
    let isShow = element.dataset.tsopen || "false";
    isShow = isShow === "true";

    if (target.classList.contains('.ts-wrapper')) return;

    event.preventDefault();
    event.stopPropagation();

    if (!isShow) tomselect.open();
    else tomselect.close();

    element.dataset.tsopen = !isShow;
});


//SINGLE CUSTOM SIZE

let timeoutCustomSizeInputs = null;
inputEvent('#product-page .options[data-option-type="multiple-selectable"] input[name="custom-width"]', false, async function(element) {
    let container = document.getElementById('product-page')
    let productId = container.dataset.productId;
    let offcanvas = element.closest('.offcanvas');
    let customSize = element.closest('.custom-size');
    let inputWidth = element;
    let inputHeight = customSize.querySelector('.custom-size-height');
    let errorElement = offcanvas.querySelector('.error-custom-sizes');
    let size = container.querySelector('input[name="size"][value="custom-size"]');
    let headerQuantity = customSize.querySelector('.header .quantity.ts-wrapper');
    let freeShippingIcon = customSize.querySelector('.tvi-free-shipping');
    let sizePreview = customSize.querySelector('.size-preview');
    let warningElement = offcanvas.querySelector('.warning');

    size.checked = false;
    size.dataset.width = '';
    size.dataset.height = '';
    inputHeight.innerHTML = '';
    sizePreview.innerHTML = '';
    hideElement(freeShippingIcon);
    slideUp(warningElement);
    if (!headerQuantity.classList.contains('hidden')) headerQuantity.classList.add('hidden');

    clearTimeout(timeoutCustomSizeInputs);
    timeoutCustomSizeInputs = setTimeout(
        function() {
            dispatchCustomEvent(
                'calculateCustomHeight',
                {
                    'productId': productId,
                    'container': container,
                    'option': offcanvas,
                    'inputWidth': inputWidth,
                    'inputHeight': inputHeight,
                    'errorElement': errorElement,
                    'inputBlur': true
                }
            );
            fireChangeEvent(size);
        },
        200
    );
});

//CUSTOM BOTH SIZE

let timeoutBothSizeInputs = null;
inputEvent('#product-page .options[data-option-type="multiple-selectable"] input[name="bothWidth"], #product-page .options[data-option-type="multiple-selectable"] input[name="bothHeight"]', false, async function(element) {
    let offcanvas = element.closest('.offcanvas');
    let customSize = element.closest('.custom-size');
    let widthInput = customSize.querySelector('input[name="bothWidth"]');
    let heightInput = customSize.querySelector('input[name="bothHeight"]');
    let size = customSize.querySelector('input[name="size"][value="custom-size"]');
    let minSizeError = offcanvas.querySelector('.error-min-size');
    let maxSizeError = offcanvas.querySelector('.error-max-size');
    let errorWidth = offcanvas.querySelector('.error-width');
    let errorHeight = offcanvas.querySelector('.error-height');
    let headerQuantity = customSize.querySelector('.header .quantity.ts-wrapper');
    let freeShippingIcon = customSize.querySelector('.tvi-free-shipping');
    let sizePreview = customSize.querySelector('.size-preview');
    let warningElement = offcanvas.querySelector('.warning');

    size.checked = false;
    size.dataset.width = '';
    size.dataset.height = '';
    sizePreview.innerHTML = '';
    hideElement(freeShippingIcon);
    slideUp(warningElement)
    if (!headerQuantity.classList.contains('hidden')) headerQuantity.classList.add('hidden');

    clearTimeout(timeoutBothSizeInputs);
    timeoutBothSizeInputs = setTimeout(
        function() {
            dispatchCustomEvent(
                'validateBothSize',
                {
                    'option': offcanvas,
                    'widthInput': widthInput,
                    'heightInput': heightInput,
                    'minSizeError': minSizeError,
                    'maxSizeError': maxSizeError,
                    'errorWidth': errorWidth,
                    'errorHeight': errorHeight
                }
            );
            fireChangeEvent(size);
        },
        300
    );
});


customDocumentEvent('customHeightCalculated successValidateBothSize', async function() {
    if (!document.querySelector('.options[data-option-type="multiple-selectable"][data-type="size"]') || document.querySelector('#modal-product')) return;
    let container = document.getElementById('product-page');
    let productId = container.dataset.productId;
    let offcanvas = container.querySelector('.options[data-option-type="multiple-selectable"][data-type="size"]');
    let customSize = container.querySelector('.custom-size');
    let size = container.querySelector('input[name="size"][value="custom-size"]');
    let width = parseFloat(container.querySelector('input[name="custom-width"], input[name="bothWidth"]').value);
    let height = parseFloat(container.querySelector('.custom-size-height').innerHTML || container.querySelector('input[name="bothHeight"]').value);
    let headerQuantity = customSize.querySelector('.header .quantity.ts-wrapper');
    let freeShippingIcon = customSize.querySelector('.tvi-free-shipping');
    let minPriceFreeShipping = parseInt(freeShippingIcon.dataset.minPriceFreeShipping);
    let sizePreview = customSize.querySelector('.size-preview');
    let pack = container.querySelector('input[name="pack"]:checked');
    let color = container.querySelector('input[name="color"]:checked');
    let supportColor = container.querySelector('input[name="support-color"]:checked');
    let warningElement = offcanvas.querySelector('.warning');

    size.checked = true;
    size.dataset.width = width;
    size.dataset.height = height;
    size.disabled = false;
    fireChangeEvent(size, false);

    customSize.querySelectorAll('.custom-price').forEach((priceContainer) => showLoaderCustomSize(priceContainer));

    let responseCalculatePrice = await calculateCustomSizePrice(
        productId,
        width,
        height,
        pack ? pack.value : null,
        color ? color.value : null,
        supportColor ? supportColor.value : null
    );
    let price = responseCalculatePrice.price;
    let warning = responseCalculatePrice.warning;

    if (warning) {
        warningElement.innerHTML = warning;
        slideDown(warningElement);
    }

    customSize.querySelectorAll('.custom-price').forEach(function(priceContainer) {
        hideLoaderCustomSize(priceContainer);
        showCustomSizePrice(priceContainer, price);
    });

    let view = await getNewTomSelectQuantity(productId, customSize.id, price);
    customSize.querySelectorAll('.quantity-selector').forEach(function(quantity) {
        if (!quantity.tomselect /*|| quantity.value !== '0'*/) return;
        if (view) {
            let parent = quantity.parentElement;
            quantity.tomselect.destroy();
            parent.innerHTML = view;
            quantity = parent.querySelector('.quantity-selector');
            let tomSelect = initTomSelectQuantity(quantity);

            tomSelect.on('dropdown_close', function () {
                let wrapper = tomSelect.wrapper;
                let quantity = tomSelect.getValue();
                if (!size) return;
                size.dataset.quantity = quantity;
                size.checked = quantity > 0;
                fireChangeEvent(size, false);
            });
        }

        quantity.tomselect.setValue(1);
    });

    if (price >= minPriceFreeShipping) showElement(freeShippingIcon);

    headerQuantity.classList.remove('hidden');
    sizePreview.innerHTML = '(' + width + ' x ' + height + ' ' + sizePreview.dataset.unitMeasure + ')';
});

customDocumentEvent('customHeightErrorCalculate errorValidateBothSize', function() {
    if (!document.querySelector('.options[data-option-type="multiple-selectable"][data-type="size"]') || document.querySelector('#modal-product')) return;
    let container = document.getElementById('product-page');
    let size = container.querySelector('input[name="size"][value="custom-size"]');
    let customSize = container.querySelector('.custom-size');

    size.checked = false;
    size.dataset.width = '';
    size.dataset.height = '';
    customSize.querySelectorAll('.custom-price').forEach(function(priceContainer) {
        showDefaultCustomSizePrice(priceContainer);
    });
    customSize.querySelectorAll('.quantity-selector').forEach(function(quantitySelector) {
        if (!quantitySelector.tomselect) return;
        quantitySelector.value = 0;
        quantitySelector.tomselect.sync();
    });
});

clickEvent('#product-page .options[data-option-type="multiple-selectable"] .custom-size .header', false, function(element, event) {
    let target = event.target;
    let customSize = element.closest('.custom-size');
    let body = customSize.querySelector('.body');

    if (target.classList.contains('.ts-wrapper') || target.closest('.ts-wrapper')) return;
    Collapse.getOrCreateInstance(body).toggle();
});

customEvent('show.bs.collapse', '#product-page .options[data-option-type="multiple-selectable"] .custom-size .body',  false, function(element){
    let customSize = element.closest('.custom-size');
    let header = customSize.querySelector('.header');
    header.setAttribute("aria-expanded", "true");
});

customEvent('hide.bs.collapse', '#product-page .options[data-option-type="multiple-selectable"] .custom-size .body',  false, function(element) {
    let customSize = element.closest('.custom-size');
    let header = customSize.querySelector('.header');
    header.setAttribute("aria-expanded", "false");
});

changeEvent('#product-page .options[data-option-type="multiple-selectable"] .custom-size .quantity', true, function(element) {
    let quantity = parseInt(element.value);
    let container = element.closest('.custom-size');
    let size = container.querySelector('input[name="size"][value="custom-size"]');
    let rawPrice = element.options[element.selectedIndex].dataset.rawPrice;

    if (size.disabled) return;
    if (size.dataset.width === '' || size.dataset.height === '') quantity = 0;

    container.querySelectorAll('.quantity-selector').forEach(function(quantitySelector) {
        if (!quantitySelector.tomselect) return;
        quantitySelector.value = quantity;
        quantitySelector.tomselect.sync();
    });
    size.dataset.quantity = quantity;
    size.checked = quantity > 0;

    fireChangeEvent(size, false);

    if (rawPrice) {
        container.querySelectorAll('.custom-price .price').forEach(function(price) {
            price.innerHTML = rawPrice;
        });
    }
});



function initTomSelectQuantities()
{
    document.querySelectorAll('#product-page .options[data-option-type="multiple-selectable"] .select-quantity').forEach(function(quantity) {
        let tomSelect = initTomSelectQuantity(quantity);

        tomSelect.on('dropdown_close', function() {
            let wrapper = tomSelect.wrapper;
            let size = wrapper.closest('.size');
            let input = document.querySelector(`input[name="size"][id="${size.htmlFor}"]`);
            let quantity = tomSelect.getValue();

            if (!input) return;

            input.checked = quantity > 0;
            input.dataset.quantity = quantity;
            fireChangeEvent(input);
        });
    });
}

function showLoaderCustomSize(container)
{
    hideElement(container.querySelector('.price-of'));
    hideElement(container.querySelector('.currency'));
    hideElement(container.querySelector('.price'));
    showElement(container.querySelector('.loader'));
}

function hideLoaderCustomSize(container)
{
    hideElement(container.querySelector('.loader'));
    showElement(container.querySelector('.price-of'));
    showElement(container.querySelector('.currency'));
    showElement(container.querySelector('.price'));
}

function showCustomSizePrice(container, price)
{
    price = formatPrice(price);
    hideElement(container.querySelector('.price-of'));
    hideElement(container.querySelector('.loader'));
    showElement(container.querySelector('.currency'));
    showElement(container.querySelector('.price'));
    container.querySelector('.price').innerHTML = price;
}

function showDefaultCustomSizePrice(container)
{
    let price = container.querySelector('.price');
    price.innerHTML = price.dataset.defaultValue;
    hideElement(container.querySelector('.loader'));
    showElement(container.querySelector('.currency'));
    showElement(price);
    showElement(container.querySelector('.price-of'));
}

function selectUniqueCustomSizeOption()
{
    let container = document.querySelector('.options[data-option-type="multiple-selectable"][data-type="size"]');
    if (!container) return;
    let option = container.querySelector('.custom-size.unique-option');
    if (!option) return;
    let input = option.querySelector('input[name="size"]');
    let quantity = option.querySelector('.quantity-selector');
    let showExpanded = option.classList.contains('show-expanded');

    option.classList.add('selected');
    input.checked = true;
    if (quantity && !quantity.classList.contains('quantity-add-to-cart')) quantity.classList.add('quantity-add-to-cart');
    if (showExpanded) {
        let header = option.querySelector('.header');
        let collapse = Collapse.getOrCreateInstance(option.querySelector('.collapse'));
        collapse.show();
        header.removeAttribute('data-bs-target');
    }
}